<template>
  <BenchmarkingWidget
    :area="props.area"
    :zone="props.zone"
    :widget="props.widget"
    :valueType="'percentage'"
  >
    <template #icon>
      <IconConversionRate style="width: 100%; height: 100%" />
    </template>
    <template #label>
      <div class="widget__label">Conversion Rate</div>
    </template>
  </BenchmarkingWidget>
</template>

<script setup lang="ts">
import type { WidgetFilter, WidgetTypeVisits, WidgetSetting } from '@/types/Widget';
import IconConversionRate from '@/icons/widgets/IconConversionRate.svg?component';
import BenchmarkingWidget from './BenchmarkingWidget.vue';

const props = defineProps<{
  widget: WidgetTypeVisits;
  area?: WidgetFilter;
  zone?: WidgetSetting;
}>();
</script>
